import React, { Fragment, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import { Grid, Typography, FormGroup, Tooltip, Collapse } from '@mui/material';

import ThumbDownAltTwoToneIcon from '@mui/icons-material/ThumbDownAltTwoTone';

import HostDashboardEventCard from '../events/HostDashboardEventCard';

import Button from '../layout/SvgButton';

const PastHostEvents = ({
    hostMe,
    myHostEvents,
    // iConfirmed
}) => {
    const location = useLocation();
    const [showPastEvents, setShowPastEvents] = useState(false);
    const [userCollapsed, setUserCollapsed] = useState(false);

    const dayBeforeYesterday = new Date();
    dayBeforeYesterday.setDate(dayBeforeYesterday.getDate() - 2);

    const isPastHostEvent = (myEvent) =>
        myEvent.confirmedHost &&
        myEvent.status === 'CONFIRMED' &&
        new Date(myEvent.bookingWhen) < dayBeforeYesterday;

    const pastHostEvents = (Array.isArray(myHostEvents) ? myHostEvents : [])
        .filter(isPastHostEvent)
        .sort((a, b) => {
            const aTime = new Date(a?.bookingWhen || 0).getTime();
            const bTime = new Date(b?.bookingWhen || 0).getTime();
            return bTime - aTime; // most recent first
        });

    const queryEventID = new URLSearchParams(location.search).get('eventID');
    const queryTargetsPast =
        Boolean(queryEventID) &&
        pastHostEvents.some(
            (myEvent) => String(myEvent._id) === String(queryEventID)
        );
    const pastOpen = userCollapsed
        ? false
        : Boolean(showPastEvents || queryTargetsPast);

    useEffect(() => {
        if (myHostEvents && myHostEvents.length > 0) {
            const unReviewedEvents = myHostEvents.forEach((myHostEvent) => {
                if (
                    myHostEvents.filter(
                        (myEvent) =>
                            isPastHostEvent(myEvent) &&
                            (!myEvent.hostReviewOfEvent ||
                                !myEvent.hostReviewOfEvent._id)
                    ).length > 0
                ) {
                    setShowPastEvents(true);
                }
            });
        }
    }, [myHostEvents]);

    useEffect(() => {
        const eventID = new URLSearchParams(location.search).get('eventID');
        if (!eventID || !myHostEvents || myHostEvents.length === 0) return;
        const targetsPast = myHostEvents.some(
            (myEvent) =>
                isPastHostEvent(myEvent) &&
                String(myEvent._id) === String(eventID)
        );
        if (targetsPast) {
            setShowPastEvents(true);
            setUserCollapsed(false);
        }
    }, [location.search, myHostEvents]);

    return (
        <>
            {pastHostEvents.length > 0 && (
                <>
                    <Typography
                        onClick={() => {
                            if (pastOpen) {
                                setUserCollapsed(true);
                                setShowPastEvents(false);
                            } else {
                                setUserCollapsed(false);
                                setShowPastEvents(true);
                            }
                        }}
                        sx={{
                            color: 'var(--link-color)',
                            cursor: 'pointer',
                            margin: pastOpen
                                ? '16px 16px 0px 16px'
                                : '16px 16px 16px 16px',
                            textAlign: 'center',
                            transition: 'margin 0.3s ease-in-out',
                        }}
                    >
                        {pastOpen ? 'Hide Past Events' : 'Show Past Events'}
                    </Typography>
                    <Collapse
                        in={pastOpen}
                        timeout={300}
                        sx={{
                            overflow: 'visible',
                            '& .MuiCollapse-wrapper': {
                                overflow: 'visible',
                            },
                            '& .MuiCollapse-wrapperInner': {
                                overflow: 'visible',
                            },
                        }}
                    >
                        <Grid
                            container
                            direction="column"
                            sx={{
                                marginBottom: '20px',
                                marginTop: showPastEvents ? '0px' : '-20px',
                                transition: 'margin 0.3s ease-in-out',
                            }}
                        >
                            <Grid item>
                                <Typography component="h2">
                                    {pastHostEvents.length > 1
                                        ? `You hosted these ${pastHostEvents.length} concerts, in the past`
                                        : `You hosted this concert, in the past`}
                                    :
                                </Typography>
                            </Grid>
                            {/* {bookingWhenWhere && bookingWhenWhere.length > 0 && bookingWhenWhere[0].when ? //check to be sure there's a valid first entry */}
                            <Grid
                                container
                                className="whenBooking"
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                                sx={{
                                    margin: '0px auto 16px',
                                    width: '100%',
                                }}
                            ></Grid>
                            {pastHostEvents.map(
                                (thisEvent, idx) =>
                                    thisEvent.bookingWhen &&
                                    thisEvent.bookingWhere && (
                                        <HostDashboardEventCard
                                            key={idx}
                                            thisEvent={thisEvent}
                                        />
                                    )
                            )}
                        </Grid>
                    </Collapse>
                </>
            )}
        </>
    );
};

PastHostEvents.propTypes = {
    host: PropTypes.object,
    myHostEvents: PropTypes.array,
    // iConfirmed: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    host: state.host,
    myHostEvents: state.event.myHostEvents,
});

export default connect(mapStateToProps, {})(PastHostEvents);
